import { render, staticRenderFns } from "./MicrosoftLoginButton.vue?vue&type=template&id=1655d038&"
import script from "./MicrosoftLoginButton.vue?vue&type=script&lang=js&"
export * from "./MicrosoftLoginButton.vue?vue&type=script&lang=js&"
import style0 from "./MicrosoftLoginButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports